import { z } from 'zod';
import { InspectionCornSchema, VideoCornSchema } from '../base.js';
import { MediaMetadataSchema } from '../base/mediaMetadata.js';
import { VideoTranscriptItemSchema } from './videoTranscript.js';
export const VideoSchema = z.object({
    description: z.string().optional(),
    fileName: z.string(),
    inspectionId: InspectionCornSchema,
    labels: z.array(z.string()),
    metadata: MediaMetadataSchema.default({}),
    order: z.number(),
    recordedDate: z.iso.datetime(),
    s3Key: z.string(),
    transcript: VideoTranscriptItemSchema.array().optional(),
    uploadedBy: z.string(),
    uploadedDate: z.string(),
    videoId: VideoCornSchema,
});
export const VideoWithSignedUrlSchema = VideoSchema.omit({ s3Key: true }).extend({
    signedUrl: z.url(),
});
